import React from 'react';
import ButtonOrange from '../../Buttons/ButtonOrange';
import './home-page-call-to-action.css';

const HomePageCallToAction = () => {
  return (
    <div className="cta-section-wrapper">
      <div className="cta-section">
        <h2 className="title-white">Ready to Explore?</h2>
        <p className="cta-description">
          Explore my work and discover how creativity and experimentation lead to unique solutions.
Whether you’re interested in my projects or want to connect, I’m always open to conversation.
        </p>
        <div className="cta-buttons">
          <ButtonOrange destination={'/projects'} text={'View My Work'} />
          <ButtonOrange destination={'/contact'} text={'Contact Me'} />
        </div>
      </div>
    </div>
  );
};

export default HomePageCallToAction;